import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { apiFetch, getAuthUserId, invalidateApiCache } from '../../utils/apiClient';
import { showCoinAwardToast, flushPendingCoinAwardToast } from '../../utils/collectorRewardsUtils';
import { useNotifications } from '../../components/NotificationSystem/NotificationSystem';
import { Autocomplete, TextField } from '@mui/material';
import { reloadFixedLayoutAds } from '../../utils/fixedLayoutAds';
import { resolveImageSrc } from '../../utils/imageUtils';
import { toTitleCase } from '../../utils/textUtils';
import { isCollectibleListedForSale } from '../../utils/marketplaceForSale';
import { buildCollectibleSearchParams } from '../../utils/vaultBrowseSearch';
import { useMessages } from '../../components/Messages/MessagesContext';
import { FiThumbsUp } from 'react-icons/fi';
import './ViewCollectionItem.css';
import MsvDetailShell from '../../components/MsvDetailShell/MsvDetailShell';
import ImageCarousel from '../../components/ImageCarousel/ImageCarousel';
import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';
import {
    driverIdPairs,
    seriesIdPairs,
    mainCategoriesIdPairs,
    diecastSubCategoriesIdPairs,
    raceUsedSubCategoriesIdPairs,
    driverWornSubCategoriesIdPairs,
    sheetMetalSubCategoriesIdPairs,
    teamIssuedSubCategoriesIdPairs,
    diecastYearCategoriesIdPairs,
    diecastVersionCategoriesIdPairs,
    tradingCardYearCategoriesIdPairs,
    tradingCardBrandCategoriesIdPairs,
    tradingCardTypeCategoriesIdPairs,
    heroCardYearCategoriesIdPairs,
    programsTicketsYearCategoriesIdPairs
} from '../../constants/dropdownIdPairs';

const ViewCollectionItem = () => {
    const { user, setUser } = useContext(UserContext);
    const [loading, setLoading] = useState(false);

    const [collectionItemData, setCollectionItemData] = useState(null);
    const [image1Data, setImage1Data] = useState(null);
    const [image2Data, setImage2Data] = useState(null);
    const { collectionItemId } = useParams();
    const location = useLocation();
    const isEditMode = location.pathname.endsWith('/edit');

    const [hasLiked, setHasLiked] = useState(false);
    const [commentText, setCommentText] = useState("");
    const [messagingOwner, setMessagingOwner] = useState(false);
    const { openDraftConversation } = useMessages();
    const { success, error: notifyError } = useNotifications();

    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const [errors] = useState({});

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deletingCollectible, setDeletingCollectible] = useState(false);

    useEffect(() => {
        flushPendingCoinAwardToast(success);
    }, [success]);

    const [formData, setFormData] = useState({
        driverName: '',
        title: '',
        description: '',
        series: '',
        team: '',
        year: '',
        mainCategory: '',
        subCategory: '',
        subSubCategory: '',
        subSubSubCategory: '',
        purchasePrice: null,
        currentValue: null,
        newItemCost: null,
        newValue: null
    });

    const [drivers, setDrivers] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState(null);

    const [series, setSeries] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState(null);

    const [mainCategories, setMainCategories] = useState([]);
    const [selectedMainCategory, setSelectedMainCategory] = useState(null);

    const [diecastSubCategories, setDiecastSubCategories] = useState([]);
    const [selectedDiecastSubCategory, setSelectedDiecastSubCategory] = useState(null);

    const [raceUsedSubCategories, setraceUsedSubCategories] = useState([]);
    const [selectedraceUsedSubCategory, setSelectedraceUsedSubCategory] = useState(null);

    const [driverWornSubCategories, setdriverWornSubCategories] = useState([]);
    const [selecteddriverWornSubCategory, setSelectedDriverWornSubCategory] = useState(null);

    const [sheetMetalSubCategories, setsheetMetalSubCategories] = useState([]);
    const [selectedsheetMetalSubCategory, setSelectedSheetMetalSubCategory] = useState(null);

    const [teamIssuedSubCategories, setTeamIssuedSubCategories] = useState([]);
    const [selectedTeamIssuedSubCategory, setSelectedTeamIssueSubCategory] = useState(null);

    const [diecastYearCategories, setDiecastYearCategories] = useState([]);
    const [selectedDiecastYearCategory, setSelectedDiecastYearCategory] = useState(null);

    const [diecastVersionCategories, setDiecastVersionCategories] = useState([]);
    const [selectedDiecastVersionCategory, setSelectedDiecastVersionCategory] = useState(null);

    const [tradingCardYearCategories, setTradingCardYearCategories] = useState([]);
    const [selectedTradingCardYearCategory, setSelectedTradingCardYearCategory] = useState(null);

    const [tradingCardBrandCategories, setTradingCardBrandCategories] = useState([]);
    const [selectedTradingCardBrandCategory, setSelectedTradingCardBrandCategory] = useState(null);

    const [tradingCardTypeCategories, setTradingCardTypeCategories] = useState([]);
    const [selectedTradingCardTypeCategory, setSelectedTradingCardTypeCategory] = useState(null);

    const [heroCardYearCategories, setHeroCardYearCategories] = useState([]);
    const [selectedHeroCardYearCategory, setSelectedHeroCardYearCategory] = useState(null);

    const [progamTicketYearCategories, setProgramTicketYearCategories] = useState([]);
    const [selectedProgramTicketYearCategory, setSelectedProgramTicketYearCategory] = useState(null);

    useEffect(() => {
        if (!collectionItemData || isEditMode) {
            return;
        }

        reloadFixedLayoutAds();
    }, [collectionItemData, isEditMode]);

    useEffect(() => {
        const fetchDrivers = async () => {
            try {
                setDrivers(driverIdPairs.sort((a, b) =>
                    a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase())
                ));

            } catch (error) {
                console.error('Error fetching drivers:', error);
            }
        };

        const fetchSeries = async () => {
            try {
                setSeries(seriesIdPairs.sort((a, b) =>
                    a.seriesName.toLowerCase().localeCompare(b.seriesName.toLowerCase())
                ));

            } catch (error) {
                console.error('Error fetching series:', error);
            }
        };

        const fetchMainCategories = async () => {
            try {
                setMainCategories(mainCategoriesIdPairs);

            } catch (error) {
                console.error('Error fetching main categories:', error);
            }
        };

        const fetchDiecastSubCategories = async () => {
            try {
                setDiecastSubCategories(diecastSubCategoriesIdPairs);

            } catch (error) {
                console.error('Error fetching diecast sub categories:', error);
            }
        };

        const fetchRaceUsedSubCategories = async () => {
            try {
                setraceUsedSubCategories(raceUsedSubCategoriesIdPairs);

            } catch (error) {
                console.error('Error fetching race used sub categories:', error);
            }
        };

        const fetchDriverWornSubCategories = async () => {
            try {
                setdriverWornSubCategories(driverWornSubCategoriesIdPairs);

            } catch (error) {
                console.error('Error fetching driver worn sub categories:', error);
            }
        };

        const fetchSheetMetalSubCategories = async () => {
            try {
                setsheetMetalSubCategories(sheetMetalSubCategoriesIdPairs);

            } catch (error) {
                console.error('Error fetching sheet metal sub categories:', error);
            }
        };

        const fetchTeamIssuedSubCategories = async () => {
            try {
                setTeamIssuedSubCategories(teamIssuedSubCategoriesIdPairs);

            } catch (error) {
                console.error('Error fetching team issued sub categories:', error);
            }
        };

        const fetchDiecastYearCategoriesIdPairs = async () => {
            try {
                const sortedPairs = [...diecastYearCategoriesIdPairs].sort((a, b) => {
                    return parseInt(b.name) - parseInt(a.name);
                });

                setDiecastYearCategories(sortedPairs);
            } catch (error) {
                console.error('Error fetching diecast year categories:', error);
            }
        };

        const fetchDiecastVersionCategories = async () => {
            try {
                const sortedPairs = [...diecastVersionCategoriesIdPairs].sort((a, b) => {
                    if (a.name === "Standard Base Version") return -1;
                    if (b.name === "Standard Base Version") return 1;
                    return a.name.localeCompare(b.name);
                });

                setDiecastVersionCategories(sortedPairs);
            } catch (error) {
                console.error('Error fetching diecast version categories:', error);
            }
        };

        const fetchTradingCardYearCategories = async () => {
            try {
                const sortedPairs = [...tradingCardYearCategoriesIdPairs].sort((a, b) => {
                    return parseInt(b.name) - parseInt(a.name);
                });

                setTradingCardYearCategories(sortedPairs);
            } catch (error) {
                console.error('Error fetching trading card year categories:', error);
            }
        };

        const fetchTradingCardBrandCategories = async () => {
            try {
                setTradingCardBrandCategories(tradingCardBrandCategoriesIdPairs);

            } catch (error) {
                console.error('Error fetching trading card brand categories:', error);
            }
        };

        const fetchTradingCardTypeCategories = async () => {
            try {
                setTradingCardTypeCategories(tradingCardTypeCategoriesIdPairs);

            } catch (error) {
                console.error('Error fetching trading card type categories:', error);
            }
        };

        const fetchHeroCardYearCategories = async () => {
            try {
                const sortedPairs = [...heroCardYearCategoriesIdPairs].sort((a, b) => {
                    return parseInt(b.name) - parseInt(a.name);
                });

                setHeroCardYearCategories(sortedPairs);
            } catch (error) {
                console.error('Error fetching hero card year categories:', error);
            }
        };

        const fetchProgramTicketYearCategories = async () => {
            try {
                const sortedPairs = [...programsTicketsYearCategoriesIdPairs].sort((a, b) => {
                    return parseInt(b.name) - parseInt(a.name);
                });

                setProgramTicketYearCategories(sortedPairs);
            } catch (error) {
                console.error('Error fetching hero card year categories:', error);
            }
        };

        fetchDrivers();
        fetchSeries();
        fetchMainCategories();
        fetchDiecastSubCategories();
        fetchRaceUsedSubCategories();
        fetchDriverWornSubCategories();
        fetchSheetMetalSubCategories();
        fetchTeamIssuedSubCategories();
        fetchDiecastYearCategoriesIdPairs();
        fetchDiecastVersionCategories();
        fetchTradingCardYearCategories();
        fetchTradingCardBrandCategories();
        fetchTradingCardTypeCategories();
        fetchHeroCardYearCategories();
        fetchProgramTicketYearCategories();
    }, []);

    useEffect(() => {
        const checkUser = () => {
            const storedUser = localStorage.getItem("user");
            if (!user && storedUser) {
                setUser(JSON.parse(storedUser));
            }
        };

        checkUser();
    }, [user, navigate, setUser]);

    useEffect(() => {
        if (!user || !collectionItemData?.collectionItemId) return;
        if (user.userId === collectionItemData.userId) return;

        const dateKey = new Date().toISOString().slice(0, 10);
        const storageKey = `msv-view-coins-${user.userId}-${collectionItemData.collectionItemId}-${dateKey}`;
        if (sessionStorage.getItem(storageKey)) return;

        const timer = window.setTimeout(async () => {
            try {
                const response = await apiFetch('/CollectorRewards/RecordItemView', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ collectionItemId: collectionItemData.collectionItemId }),
                });

                if (!response.ok) return;

                const data = await response.json();
                sessionStorage.setItem(storageKey, '1');
                showCoinAwardToast(success, data.coinAward);
            } catch (err) {
                console.error('Collector view reward error:', err);
            }
        }, 5000);

        return () => window.clearTimeout(timer);
    }, [user, collectionItemData, success]);

    useEffect(() => {
        if (!collectionItemData) {
            const fetchShipmentData = async () => {
                setLoading(true);
                try {
                    const requestBody = {
                        CollectionItemId: collectionItemId,
                        UserId: user?.userId ?? null
                    };

                    const response = await apiFetch('/Collectibles/GetCollectionItemById', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    });

                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.error || 'Failed to fetch collection item details');
                    }

                    const data = await response.json();
                    if (data) {
                        if (!data.comments) {
                            data.comments = [];
                        }

                        setCollectionItemData(data);

                        const displayImage = resolveImageSrc(data);
                        if (displayImage) {
                            setImage1Data(displayImage);
                        }
                        const secondImage =
                            (typeof data.imageUrl2 === 'string' && data.imageUrl2) ||
                            (typeof data.ImageUrl2 === 'string' && data.ImageUrl2) ||
                            null;
                        setImage2Data(secondImage);

                        setFormData(prev => ({
                                ...prev,
                                title: data.title,
                                description: data.description,
                                driverName: data.driver,
                                team: data.team || '',
                                year: data.year || '',
                                newItemCost: data.itemCostOriginalValue,
                                newValue: data.itemValueOriginalValue,
                                purchasePrice: data.itemCostOriginalValue,
                                currentValue: data.itemValueOriginalValue
                            }));

                            const matchedDriver = driverIdPairs.find(driver => driver.fullName === data.driver);
                            if (matchedDriver) {
                                setSelectedDriver(matchedDriver);
                                setFormData(prev => ({ ...prev, driverName: matchedDriver.fullName }));
                            }
                            const matchedSeries = seriesIdPairs.find(series => series.seriesName === data.series);
                            if (matchedSeries) {
                                setSelectedSeries(matchedSeries);
                                setFormData(prev => ({ ...prev, series: matchedSeries.seriesName }));
                            }
                            const matchedMainCategory = mainCategoriesIdPairs.find(mainCategory => mainCategory.name === data.mainCategory);
                            if (matchedMainCategory) {
                                setSelectedMainCategory(matchedMainCategory);
                                setFormData(prev => ({ ...prev, mainCategory: matchedMainCategory.name }));

                                // Set SubCategory
                                switch (matchedMainCategory.name) {
                                    case "Diecasts": {
                                        const sub = diecastSubCategoriesIdPairs.find(item => item.name === data.subCategory);
                                        if (sub) {
                                            setSelectedDiecastSubCategory(sub);
                                            setFormData(prev => ({ ...prev, subCategory: sub.name }));
                                        }

                                        const subSub = diecastYearCategoriesIdPairs.find(item => item.name === data.subSubCategory);
                                        if (subSub) {
                                            setSelectedDiecastYearCategory(subSub);
                                            setFormData(prev => ({ ...prev, subSubCategory: subSub.name }));
                                        }

                                        const subSubSub = diecastVersionCategoriesIdPairs.find(item => item.name === data.subSubSubCategory);
                                        if (subSubSub) {
                                            setSelectedDiecastVersionCategory(subSubSub);
                                            setFormData(prev => ({ ...prev, subSubSubCategory: subSubSub.name }));
                                        }
                                        break;
                                    }

                                    case "Trading Cards": {
                                        const sub = tradingCardYearCategoriesIdPairs.find(item =>
                                            item.id === String(data.subCategoryId) || item.name === data.subCategory
                                        );
                                        if (sub) {
                                            setSelectedTradingCardYearCategory(sub);
                                            setFormData(prev => ({ ...prev, subCategory: sub.name }));
                                            setCollectionItemData(prev => ({
                                                ...prev,
                                                subCategory: sub.name,
                                                subCategoryId: parseInt(sub.id) || 0  // <-- force a valid number
                                            }));
                                        }

                                        const subSub = tradingCardBrandCategoriesIdPairs.find(item => item.name === data.subSubCategory);
                                        if (subSub) {
                                            setSelectedTradingCardBrandCategory(subSub);
                                            setFormData(prev => ({ ...prev, subSubCategory: subSub.name }));
                                        }

                                        const subSubSub = tradingCardTypeCategoriesIdPairs.find(item => item.name === data.subSubSubCategory);
                                        if (subSubSub) {
                                            setSelectedTradingCardTypeCategory(subSubSub);
                                            setFormData(prev => ({ ...prev, subSubSubCategory: subSubSub.name }));
                                        }
                                        break;
                                    }

                                    case "Hero Cards / Post Cards": {
                                        const sub = heroCardYearCategoriesIdPairs.find(item => item.name === data.subCategory);
                                        if (sub) {
                                            setSelectedHeroCardYearCategory(sub);
                                            setFormData(prev => ({ ...prev, subCategory: sub.name }));
                                        }
                                        break;
                                    }

                                    case "Programs / Tickets": {
                                        const sub = programsTicketsYearCategoriesIdPairs.find(item => item.name === data.subCategory);
                                        if (sub) {
                                            setSelectedProgramTicketYearCategory(sub);
                                            setFormData(prev => ({ ...prev, subCategory: sub.name }));
                                        }
                                        break;
                                    }

                                    case "Race Used / Team Issued": {
                                        const sub = raceUsedSubCategoriesIdPairs.find(item => item.name === data.subCategory);
                                        if (sub) {
                                            setSelectedraceUsedSubCategory(sub);
                                            setFormData(prev => ({ ...prev, subCategory: sub.name }));
                                        }

                                        if (data.subCategory === "Sheet Metal / Body Panel") {
                                            const subSub = sheetMetalSubCategoriesIdPairs.find(item => item.name === data.subSubCategory);
                                            if (subSub) {
                                                setSelectedSheetMetalSubCategory(subSub);
                                                setFormData(prev => ({ ...prev, subSubCategory: subSub.name }));
                                            }
                                        } else if (data.subCategory === "Driver Worn") {
                                            const subSub = driverWornSubCategoriesIdPairs.find(item => item.name === data.subSubCategory);
                                            if (subSub) {
                                                setSelectedDriverWornSubCategory(subSub);
                                                setFormData(prev => ({ ...prev, subSubCategory: subSub.name }));
                                            }
                                        } else if (data.subCategory === "Team Issued") {
                                            const subSub = teamIssuedSubCategoriesIdPairs.find(item => item.name === data.subSubCategory);
                                            if (subSub) {
                                                setSelectedTeamIssueSubCategory(subSub);
                                                setFormData(prev => ({ ...prev, subSubCategory: subSub.name }));
                                            }
                                        }
                                        break;
                                    }

                                    default:
                                        break;
                                }
                            }
                    } else {
                        setError('No shipment data found or access denied.');
                    }
                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };
            fetchShipmentData();
        }
    }, [collectionItemId]);

    const handleThumbsUpClick = async () => {
        if (!user?.userId || !collectionItemData || hasLiked || collectionItemData.userLikedCollectibleItem) {
            return;
        }

        const previousLikes = collectionItemData.numberOfLikes;
        setHasLiked(true);
        setCollectionItemData((prev) => ({
            ...prev,
            numberOfLikes: (prev.numberOfLikes || 0) + 1,
            userLikedCollectibleItem: true,
        }));

        try {
            const response = await apiFetch('/Collectibles/LikeCollectionItem', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    CollectionItemId: collectionItemData.collectionItemId,
                    UserId: user.userId
                }),
            });

            if (!response.ok) throw new Error('Failed to like item');

            const result = await response.json();
            if (!result.liked) {
                setHasLiked(false);
                setCollectionItemData((prev) => ({
                    ...prev,
                    numberOfLikes: previousLikes,
                    userLikedCollectibleItem: false,
                }));
                return;
            }

            showCoinAwardToast(success, result.coinAward);
        } catch (err) {
            console.error('Error liking item:', err);
            setHasLiked(false);
            setCollectionItemData((prev) => ({
                ...prev,
                numberOfLikes: previousLikes,
                userLikedCollectibleItem: false,
            }));
            setError(err.message);
        }
    };

    const handleSellOnMarketplace = () => {
        navigate('/createmarketplaceitem', {
            state: { collectionItemId: collectionItemData.collectionItemId },
        });
    };

    const handleViewMarketplaceListing = (opts = {}) => {
        const marketplaceItemId = collectionItemData?.marketplaceItemId;
        if (!marketplaceItemId) return;
        const editQuery = opts.openEdit ? '?edit=1' : '';
        navigate(`/marketplaceItem/${marketplaceItemId}${editQuery}`);
    };

    const formatMarketplacePrice = (price) => {
        const n = Number(price);
        if (!Number.isFinite(n)) return null;
        return n.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
    };

    const isListedForSale = isCollectibleListedForSale(collectionItemData);
    const marketplaceListingStatus = collectionItemData?.marketplaceListingStatus || '';
    const hasLinkedMarketplaceListing = Boolean(collectionItemData?.marketplaceItemId);
    const isUnderReviewListing = marketplaceListingStatus === 'UnderReview';
    const isExpiredListing = marketplaceListingStatus === 'Expired';
    const isRejectedListing = marketplaceListingStatus === 'Rejected';
    const isRemovedListing = marketplaceListingStatus === 'Removed';
    const canManageMarketplaceListing =
        hasLinkedMarketplaceListing &&
        (isListedForSale ||
            isUnderReviewListing ||
            isExpiredListing ||
            isRejectedListing ||
            isRemovedListing);
    const marketplacePriceLabel = formatMarketplacePrice(collectionItemData?.marketplacePrice);

    const handleEditClick = () => {
        // Replace view in history so Back after save returns to the vault, not edit.
        window.location.replace(`/collectionItem/${collectionItemId}/edit`);
    };

    const handleSaveClick = async () => {

        const requestBody = {
            collectibleId: collectionItemId, // make sure you have this from props or state
            userId: user.userId,           // assuming you have user from context
            driverName: formData.driverName,
            title: formData.title,
            description: formData.description,
            series: formData.series,
            team: formData.team,
            year: formData.year,
            mainCategory: formData.mainCategory,
            subCategory: formData.subCategory,
            subSubCategory: formData.subSubCategory,
            subSubSubCategory: formData.subSubSubCategory,
            purchasePrice: formData.newItemCost,
            currentValue: formData.newValue,
            purchasePriceOriginalValue: formData.purchasePrice,
            CurrentValueOriginalValue: formData.currentValue,
            zippedImages: "", // handle this as needed
            images: []        // handle this as needed
        };

        try {
            const response = await apiFetch('/Collectibles/UpdateCollectible', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                console.error('Failed to update collectible');
                return;
            }

            const result = await response.json();
            if (result) {
                setFormData(prev => ({
                    ...prev,
                    purchasePrice: prev.newItemCost,
                    currentValue: prev.newValue
                }));

            } else {
                console.error('Update API returned false');
            }

        } catch (error) {
            console.error('Error updating collectible:', error);
        }


        setCollectionItemData(prev => ({
            ...prev,
            title: formData.title
        }));

        setCollectionItemData(prev => ({
            ...prev,
            description: formData.description
        }));

        setCollectionItemData(prev => ({
            ...prev,
            driver: formData.driverName
        }));

        setCollectionItemData(prev => ({
            ...prev,
            series: formData.series
        }));

        setCollectionItemData(prev => ({
            ...prev,
            mainCategory: formData.mainCategory
        }));

        setCollectionItemData(prev => ({
            ...prev,
            subCategory: formData.subCategory
        }));

        setCollectionItemData(prev => ({
            ...prev,
            subSubCategory: formData.subSubCategory
        }));

        setCollectionItemData(prev => ({
            ...prev,
            subSubSubCategory: formData.subSubSubCategory
        }));

        window.location.replace(`/collectionItem/${collectionItemId}`);
    };

    const handleCancelClick = () => {
        window.location.replace(`/collectionItem/${collectionItemId}`);
    };

    const handlePostComment = async () => {
        try {
            const response = await apiFetch('/Collectibles/PostComment', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Username: user.username,
                    CollectibleItemId: collectionItemData.collectionItemId,
                    Comment: commentText
                }),
            });

            if (response.ok) {
                const newComment = await response.json();
                setCollectionItemData(prev => ({
                    ...prev,
                    comments: [...(prev.comments || []), newComment]
                }));
                setCommentText("");
                showCoinAwardToast(success, newComment.coinAward);
            } else {
                throw new Error("Failed to post comment");
            }
        } catch (err) {
            console.error("Comment post error:", err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDeleteClick = () => {
        setShowDeleteConfirm(true);
    };

    const handleDuplicateClick = () => {
        navigate('/additems?type=collectible', {
            state: {
                prefillData: {
                    driverName: formData.driverName,
                    title: formData.title,
                    description: formData.description,
                    series: formData.series,
                    team: formData.team,
                    year: formData.year,
                    mainCategory: formData.mainCategory,
                    subCategory: formData.subCategory,
                    subSubCategory: formData.subSubCategory,
                    subSubSubCategory: formData.subSubSubCategory,
                    purchasePrice: formData.purchasePrice,
                    currentValue: formData.currentValue
                }
            }
        });
    };

    const handleMessageOwner = async () => {
        const ownerUserId = Number(collectionItemData?.userId);
        if (!Number.isFinite(ownerUserId) || ownerUserId <= 0) {
            notifyError('Could not find this collector to message.');
            return;
        }
        if (!user?.userId && !getAuthUserId()) {
            navigate('/login', {
                state: {
                    redirectTo: location.pathname + location.search,
                    message: 'Please log in to send a message.',
                },
            });
            return;
        }
        if (messagingOwner) return;
        setMessagingOwner(true);
        try {
            await openDraftConversation({
                otherUserId: ownerUserId,
                otherUsername: collectionItemData?.username || 'User',
                collectionItemId: Number(collectionItemId) || undefined,
                itemTitle: collectionItemData?.title || collectionItemData?.driverName || '',
            });
        } catch (err) {
            console.error('Failed to open chat:', err);
            if (err?.status === 401) {
                notifyError('Please log in again to send a message.');
                return;
            }
            notifyError(err?.message || 'Could not open chat. Please try again.');
        } finally {
            setMessagingOwner(false);
        }
    };

    const confirmDeleteCollectible = async () => {
        setDeletingCollectible(true);
        try {
            const response = await apiFetch('/Collectibles/DeleteCollectibleById', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    collectionItemId: collectionItemId,
                    userId: user.userId
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to delete the collectible');
            }

            setShowDeleteConfirm(false);

            const isDiecastItem =
                collectionItemData?.mainCategory === 'Diecasts' ||
                formData.mainCategory === 'Diecasts';
            const vaultType = isDiecastItem ? 'diecasts' : 'collectibles';
            const stateKey = isDiecastItem
                ? 'userDiecastsSearchState'
                : 'userCollectiblesSearchState';

            // Keep My Items filters (driver/series/etc.) from before this view; drop list caches
            // so the deleted card cannot be restored from session/bfcache.
            let returnSearch = `type=${vaultType}`;
            try {
                const raw = sessionStorage.getItem(stateKey);
                if (raw) {
                    const saved = JSON.parse(raw);
                    returnSearch = buildCollectibleSearchParams(saved.formData || {}, {
                        isDiecastsMode: isDiecastItem,
                        sortBy: saved.sortBy || 'recent',
                        page: '1',
                        type: vaultType,
                        hasLikes: !!saved.hasLikes,
                    }).toString();
                }
            } catch {
                // Fall back to unfiltered vault type URL.
            }

            sessionStorage.removeItem('userCollectiblesSearchState');
            sessionStorage.removeItem('userDiecastsSearchState');
            sessionStorage.removeItem('userCollectiblesPendingRestore');
            sessionStorage.removeItem('userDiecastsPendingRestore');
            sessionStorage.removeItem('searchState');
            invalidateApiCache('/Collectibles/UserSearchCollectibles');
            invalidateApiCache('/Collectibles/SearchCollectibles');

            // Full navigation avoids bfcache restoring the pre-delete grid.
            window.location.href = `/myitems?${returnSearch}`;
        } catch (error) {
            console.error('Error deleting collectible:', error);
            notifyError('Failed to delete collectible.');
            setShowDeleteConfirm(false);
        } finally {
            setDeletingCollectible(false);
        }
    };

    if (loading) {
        return (
            <MsvDetailShell
                loading
                showFooter={false}
            />
        );
    }

    if (error) {
        return <MsvDetailShell error={`Error: ${error}`} showFooter={false} />;
    }

    if (!collectionItemData) {
        return (
            <MsvDetailShell
                error="No collection item data available."
                showFooter={false}
            />
        );
    }

    const currentUserId = getAuthUserId() ?? Number(user?.userId) ?? null;
    const isOwner =
        Number.isFinite(currentUserId) &&
        currentUserId > 0 &&
        currentUserId === Number(collectionItemData.userId);
    const canMessageOwner = !isEditMode && !isOwner;
    const isLikedByViewer = hasLiked || collectionItemData.userLikedCollectibleItem;

    return (
        <>
            <MsvDetailShell onBack={() => navigate(-1)} backLabel="Back">
                <div className="view-collection-container">
                        {isEditMode ? (
                            <>
                                <div className="image-container">
                                    <ImageCarousel
                                        images={[image1Data, image2Data].filter(Boolean)}
                                        alt="Collectible"
                                    />
                                </div>

                                <div className="sign-up-form-group">
                                    <label>
                                        Title<span className="asterisk">*</span>
                                        <span style={{ float: 'right', fontSize: '0.9em' }}>
                                            {formData.title.length}/80
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 80) {
                                                handleChange(e);
                                            }
                                        }}
                                        className={errors.title ? "error" : ""}
                                        style={{ fontSize: '1rem' }}
                                    />
                                    {errors.title && <p className="sign-up-error">{errors.title}</p>}
                                </div>

                                <div className="sign-up-form-group">
                                    <label>
                                        Description<span className="asterisk">*</span>
                                        <span style={{ float: 'right', fontSize: '0.9em' }}>
                                            {formData.description.length}/500
                                        </span>
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 500) {
                                                handleChange(e);
                                            }
                                        }}
                                        rows={3}
                                        className={`description-textarea ${errors.description ? "error" : ""}`}
                                    />
                                    {errors.description && <p className="sign-up-error">{errors.description}</p>}
                                </div>

                                <div className="sign-up-form-group">
                                    <label htmlFor="driverDropdown">Select Driver<span className="asterisk">*</span></label>
                                </div>
                                <Autocomplete
                                    disablePortal
                                    options={drivers}
                                    getOptionLabel={(option) =>
                                        `${option.fullName}`
                                    }
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    value={selectedDriver || null}
                                    onChange={(event, newValue) => {
                                        setSelectedDriver(newValue);
                                        setFormData(prev => ({ ...prev, driverName: newValue?.fullName || '' }));
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                    sx={{ marginBottom: 2 }}
                                />

                                <div className="sign-up-form-group">
                                    <label htmlFor="seriesDropdown" >Select Series<span className="asterisk">*</span></label>
                                </div>
                                <Autocomplete
                                    disablePortal
                                    options={series}
                                    getOptionLabel={(option) =>
                                        `${option.seriesName}`
                                    }
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    value={selectedSeries || null}
                                    onChange={(event, newValue) => {
                                        setSelectedSeries(newValue);
                                        setFormData(prev => ({ ...prev, series: newValue?.seriesName || '' }));
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                    sx={{ marginBottom: 2 }}
                                />

                                <>
                                    <div className="sign-up-form-group">
                                        <label htmlFor="mainCategoryDropdown">Select Main Category<span className="asterisk">*</span></label>
                                    </div>
                                    <Autocomplete
                                        disablePortal
                                        options={mainCategories}
                                        getOptionLabel={(option) => `${option.name}`}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        value={selectedMainCategory || null}
                                        onChange={(event, newValue) => {
                                            setSelectedMainCategory(newValue);
                                            // Reset all dependent subcategories when main category changes
                                            setSelectedDiecastSubCategory(null);
                                            setSelectedraceUsedSubCategory(null);
                                            setSelectedSheetMetalSubCategory(null);
                                            setSelectedDriverWornSubCategory(null);
                                            setSelectedTeamIssueSubCategory(null);
                                            setSelectedDiecastYearCategory(null);
                                            setSelectedDiecastVersionCategory(null);
                                            setSelectedTradingCardYearCategory(null);
                                            setSelectedTradingCardBrandCategory(null);
                                            setSelectedTradingCardTypeCategory(null);
                                            setSelectedHeroCardYearCategory(null);
                                            setSelectedProgramTicketYearCategory(null);
                                            setFormData(prev => ({ ...prev, mainCategory: newValue?.name || '', subCategory: '', subSubCategory: '', subSubSubCategory: '' }));
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                        sx={{ marginBottom: 2 }}
                                    />
                                </>

                                {selectedMainCategory?.name === "Diecasts" && (
                                    <>
                                        <div className="sign-up-form-group">
                                            <label htmlFor="diecastSubcategoryDropdown">Select Diecast Subcategory</label>
                                        </div>
                                        <Autocomplete
                                            disablePortal
                                            options={diecastSubCategories}
                                            getOptionLabel={(option) => `${option.name}`}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            value={selectedDiecastSubCategory || null}
                                            onChange={(event, newValue) => {
                                                setSelectedDiecastSubCategory(newValue);
                                                setFormData(prev => ({ ...prev, subCategory: newValue?.name || '', subSubCategory: '', subSubSubCategory: '' }));
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ marginBottom: 2 }}
                                        />

                                        {selectedMainCategory?.name === "Diecasts" && selectedDiecastSubCategory && (
                                            <>
                                                <div className="sign-up-form-group">
                                                    <label htmlFor="diecastYearCategoryDropdown">Select Diecast Year</label>
                                                </div>
                                                <Autocomplete
                                                    disablePortal
                                                    options={diecastYearCategories}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={selectedDiecastYearCategory || null}
                                                    onChange={(event, newValue) => {
                                                        setSelectedDiecastYearCategory(newValue);
                                                        setSelectedDiecastVersionCategory(null);
                                                        setFormData(prev => ({ ...prev, subSubCategory: newValue?.name || '', subSubSubCategory: '' }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}

                                        {selectedMainCategory?.name === "Diecasts" && selectedDiecastSubCategory && selectedDiecastYearCategory && (
                                            <>
                                                <div className="sign-up-form-group">
                                                    <label htmlFor="diecastVersionCategoryDropdown">Select Diecast Version</label>
                                                </div>
                                                <Autocomplete
                                                    disablePortal
                                                    options={diecastVersionCategories}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={selectedDiecastVersionCategory || null}
                                                    onChange={(event, newValue) => {
                                                        setSelectedDiecastVersionCategory(newValue);
                                                        setFormData(prev => ({ ...prev, subSubSubCategory: newValue?.name || '' }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}
                                    </>
                                )}

                                {selectedMainCategory?.name === "Trading Cards" && (
                                    <>
                                        <div className="sign-up-form-group">
                                            <label htmlFor="tradingCardYearDropdown">Select Trading Card Year</label>
                                        </div>
                                        <Autocomplete
                                            disablePortal
                                            options={tradingCardYearCategories}
                                            getOptionLabel={(option) => `${option.name}`}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            value={selectedTradingCardYearCategory || null}
                                            onChange={(event, newValue) => {
                                                setSelectedTradingCardYearCategory(newValue);
                                                setSelectedTradingCardBrandCategory(null);
                                                setSelectedTradingCardTypeCategory(null);
                                                setFormData(prev => ({ ...prev, subCategory: newValue?.name || '', subSubCategory: '', subSubSubCategory: '' }));
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ marginBottom: 2 }}
                                        />

                                        {selectedMainCategory?.name === "Trading Cards" && selectedTradingCardYearCategory && (
                                            <>
                                                <div className="sign-up-form-group">
                                                    <label htmlFor="tradingCardBrandCategoryDropdown">Select Trading Card Brand</label>
                                                </div>
                                                <Autocomplete
                                                    disablePortal
                                                    options={tradingCardBrandCategories}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={selectedTradingCardBrandCategory || null}
                                                    onChange={(event, newValue) => {
                                                        setSelectedTradingCardBrandCategory(newValue);
                                                        setSelectedTradingCardTypeCategory(null);
                                                        setFormData(prev => ({ ...prev, subSubCategory: newValue?.name || '', subSubSubCategory: '' }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}

                                        {selectedMainCategory?.name === "Trading Cards" && selectedTradingCardYearCategory && selectedTradingCardBrandCategory && (
                                            <>
                                                <div className="sign-up-form-group">
                                                    <label htmlFor="tradingCardTypeCategoryDropdown">Select Trading Card Type</label>
                                                </div>
                                                <Autocomplete
                                                    disablePortal
                                                    options={tradingCardTypeCategories}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={selectedTradingCardTypeCategory || null}
                                                    onChange={(event, newValue) => {
                                                        setSelectedTradingCardTypeCategory(newValue);
                                                        setFormData(prev => ({ ...prev, subSubSubCategory: newValue?.name || '' }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}

                                        {selectedraceUsedSubCategory?.name === "Driver Worn" && (
                                            <>
                                                <div className="sign-up-form-group">
                                                    <label htmlFor="driverWornSubCategoryDropdown">Select Driver Worn Subcategory</label>
                                                </div>
                                                <Autocomplete
                                                    disablePortal
                                                    options={driverWornSubCategories}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={selecteddriverWornSubCategory || null}
                                                    onChange={(event, newValue) => {
                                                        setSelectedDriverWornSubCategory(newValue);
                                                        setFormData(prev => ({ ...prev, subSubCategory: newValue?.name || '', subSubSubCategory: '' }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}
                                    </>
                                )}

                                {selectedMainCategory?.name === "Race Used / Team Issued" && (
                                    <>
                                        <div className="sign-up-form-group">
                                            <label htmlFor="raceUsedSubCategoryDropdown">Select Race Used Subcategory</label>
                                        </div>
                                        <Autocomplete
                                            disablePortal
                                            options={raceUsedSubCategories}
                                            getOptionLabel={(option) => `${option.name}`}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            value={selectedraceUsedSubCategory || null}
                                            onChange={(event, newValue) => {
                                                setSelectedraceUsedSubCategory(newValue);
                                                setSelectedSheetMetalSubCategory(null);
                                                setSelectedDriverWornSubCategory(null);
                                                setSelectedTeamIssueSubCategory(null);
                                                setSelectedDiecastYearCategory(null);
                                                setSelectedDiecastVersionCategory(null);
                                                setSelectedTradingCardYearCategory(null);
                                                setSelectedTradingCardBrandCategory(null);
                                                setSelectedTradingCardTypeCategory(null);

                                                setFormData(prev => ({ ...prev, subCategory: newValue?.name || '', subSubCategory: '', subSubSubCategory: '' }));
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ marginBottom: 2 }}
                                        />

                                        {selectedraceUsedSubCategory?.name === "Sheet Metal / Body Panel" && (
                                            <>
                                                <div className="sign-up-form-group">
                                                    <label htmlFor="sheetMetalSubCategoryDropdown">Select Sheet Metal Subcategory</label>
                                                </div>
                                                <Autocomplete
                                                    disablePortal
                                                    options={sheetMetalSubCategories}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={selectedsheetMetalSubCategory || null}
                                                    onChange={(event, newValue) => {
                                                        setSelectedSheetMetalSubCategory(newValue);
                                                        setFormData(prev => ({ ...prev, subSubCategory: newValue?.name || '', subSubSubCategory: '' }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}

                                        {selectedraceUsedSubCategory?.name === "Team Issued" && (
                                            <>
                                                <div className="sign-up-form-group">
                                                    <label htmlFor="teamIssuedSubCategoryDropdown">Select Team Issued Subcategory</label>
                                                </div>
                                                <Autocomplete
                                                    disablePortal
                                                    options={teamIssuedSubCategories}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={selectedTeamIssuedSubCategory || null}
                                                    onChange={(event, newValue) => {
                                                        setSelectedTeamIssueSubCategory(newValue);
                                                        setFormData(prev => ({ ...prev, subSubCategory: newValue?.name || '', subSubSubCategory: '' }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}

                                        {selectedraceUsedSubCategory?.name === "Driver Worn" && (
                                            <>
                                                <div className="sign-up-form-group">
                                                    <label htmlFor="driverWornSubCategoryDropdown">Select Driver Worn Subcategory</label>
                                                </div>
                                                <Autocomplete
                                                    disablePortal
                                                    options={driverWornSubCategories}
                                                    getOptionLabel={(option) => `${option.name}`}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={selecteddriverWornSubCategory || null}
                                                    onChange={(event, newValue) => {
                                                        setSelectedDriverWornSubCategory(newValue);
                                                        setFormData(prev => ({ ...prev, subSubCategory: newValue?.name || '', subSubSubCategory: '' }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ marginBottom: 2 }}
                                                />
                                            </>
                                        )}
                                    </>
                                )}

                                {selectedMainCategory?.name === "Hero Cards / Post Cards" && (
                                    <>
                                        <div className="sign-up-form-group">
                                            <label htmlFor="herocardYearCategoryDropdown">Select Year</label>
                                        </div>
                                        <Autocomplete
                                            disablePortal
                                            options={heroCardYearCategories}
                                            getOptionLabel={(option) => `${option.name}`}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            value={selectedHeroCardYearCategory || null}
                                            onChange={(event, newValue) => {
                                                setSelectedHeroCardYearCategory(newValue);
                                                setFormData(prev => ({ ...prev, subCategory: newValue?.name || '', subSubCategory: '', subSubSubCategory: '' }));
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ marginBottom: 2 }}
                                        />
                                    </>
                                )}

                                {selectedMainCategory?.name === "Programs / Tickets" && (
                                    <>
                                        <div className="sign-up-form-group">
                                            <label htmlFor="programTicketYearCategoryDropdown">Select Year</label>
                                        </div>
                                        <Autocomplete
                                            disablePortal
                                            options={progamTicketYearCategories}
                                            getOptionLabel={(option) => `${option.name}`}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            value={selectedProgramTicketYearCategory || null}
                                            onChange={(event, newValue) => {
                                                setSelectedProgramTicketYearCategory(newValue);
                                                setFormData(prev => ({ ...prev, subCategory: newValue?.name || '', subSubCategory: '', subSubSubCategory: '' }));
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ marginBottom: 2 }}
                                        />
                                    </>
                                )}

                                <div className="sign-up-form-group">
                                    <label>Purchase Price ($)</label>
                                    <input
                                        style={{ fontSize: '1rem' }}
                                        type="number"
                                        name="newItemCost"
                                        step="0.01"
                                        min="0"
                                        value={formData.newItemCost ?? ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '') {
                                                setFormData(prev => ({ ...prev, newItemCost: null }));
                                            } else if (/^\d+(\.\d{0,2})?$/.test(value)) {
                                                setFormData(prev => ({ ...prev, newItemCost: parseFloat(value) }));
                                            }
                                        }}
                                    />
                                </div>

                                <div className="sign-up-form-group">
                                    <label>Current Value ($)</label>
                                    <input
                                        style={{ fontSize: '1rem' }}
                                        type="number"
                                        name="newValue"
                                        step="0.01"
                                        min="0"
                                        value={formData.newValue ?? ''}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '') {
                                                setFormData(prev => ({ ...prev, newValue: null }));
                                            } else if (/^\d+(\.\d{0,2})?$/.test(value)) {
                                                setFormData(prev => ({ ...prev, newValue: parseFloat(value) }));
                                            }
                                        }}
                                    />
                                </div>

                                <div className="vci-edit-actions" style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '20px' }}>
                                    <button onClick={handleSaveClick} className="view-button vci-btn-save" style={{ backgroundColor: 'green' }}>
                                        Save Changes
                                    </button>
                                    <button onClick={handleCancelClick} className="view-button vci-btn-cancel" style={{ backgroundColor: 'red' }}>
                                        Cancel
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="no-edit">
                                    <h2 className="collection-title">{toTitleCase(collectionItemData.title)}</h2>
                                    <div className="vci-showcase msv-detail-card">
                                        <div className="image-container msv-detail-media">
                                            <ImageCarousel
                                                images={[image1Data, image2Data].filter(Boolean)}
                                                alt="Collectible"
                                            />
                                            {isListedForSale && (
                                                <span className="msv-for-sale-badge">
                                                    For Sale{marketplacePriceLabel ? ` · ${marketplacePriceLabel}` : ''}
                                                </span>
                                            )}
                                            {isOwner && isUnderReviewListing && (
                                                <span className="msv-for-sale-badge">
                                                    Listing under review
                                                </span>
                                            )}
                                            {isOwner && isExpiredListing && (
                                                <span className="msv-for-sale-badge">
                                                    Listing expired
                                                </span>
                                            )}
                                            {isOwner && isRejectedListing && (
                                                <span className="msv-for-sale-badge">
                                                    Listing rejected
                                                </span>
                                            )}
                                            {isOwner && isRemovedListing && (
                                                <span className="msv-for-sale-badge">
                                                    Listing paused
                                                </span>
                                            )}
                                        </div>
                                        <div className="text-container msv-detail-info">
                                            {collectionItemData.description && (
                                                <p className="vci-description">{collectionItemData.description}</p>
                                            )}
                                            <p><strong>Driver:</strong> {collectionItemData.driver}</p>
                                            <p><strong>Series:</strong> {collectionItemData.series}</p>
                                            {isListedForSale && (
                                                <p>
                                                    <strong>Marketplace:</strong>{' '}
                                                    Listed for sale
                                                    {marketplacePriceLabel ? ` at ${marketplacePriceLabel}` : ''}
                                                </p>
                                            )}
                                            {isOwner && isUnderReviewListing && (
                                                <p>
                                                    <strong>Marketplace:</strong>{' '}
                                                    Listing is pending review. It will show as For Sale once approved.
                                                </p>
                                            )}
                                            {isOwner && isExpiredListing && (
                                                <p>
                                                    <strong>Marketplace:</strong>{' '}
                                                    Listing expired. Renew it from My Listings to keep it for sale.
                                                </p>
                                            )}
                                            {isOwner && isRejectedListing && (
                                                <p>
                                                    <strong>Marketplace:</strong>{' '}
                                                    Listing was not approved. Edit and resubmit for approval, or delete it from My Listings.
                                                </p>
                                            )}
                                            {isOwner && isRemovedListing && (
                                                <p>
                                                    <strong>Marketplace:</strong>{' '}
                                                    Listing is paused. Relist it or delete it from My Listings.
                                                </p>
                                            )}
                                            <p>
                                                <strong>Category:</strong>{" "}
                                                {collectionItemData.mainCategory}
                                                {collectionItemData.subCategory != null && collectionItemData.subCategoryId > 0 ? ` > ${collectionItemData.subCategory}` : ""}
                                                {collectionItemData.subSubCategory != null && collectionItemData.subSubCategoryId > 0 ? ` > ${collectionItemData.subSubCategory}` : ""}
                                                {collectionItemData.subSubSubCategory != null && collectionItemData.subSubSubCategoryId > 0 ? ` > ${collectionItemData.subSubSubCategory}` : ""}
                                            </p>
                                            <p className="vci-likes-row">
                                                <strong>Likes:</strong>
                                                <span className="vci-likes-value">
                                                    <span className="vci-likes-count">
                                                        {collectionItemData.numberOfLikes ?? 0}
                                                    </span>
                                                    {user && user.userId !== collectionItemData.userId && (
                                                        <button
                                                            type="button"
                                                            className={`thumbs-up-button${isLikedByViewer ? ' is-liked' : ''}`}
                                                            onClick={handleThumbsUpClick}
                                                            disabled={isLikedByViewer}
                                                            aria-label={isLikedByViewer ? 'Liked' : 'Like this item'}
                                                            aria-pressed={isLikedByViewer}
                                                        >
                                                            <FiThumbsUp aria-hidden className="thumbs-up-icon" />
                                                            <span className="thumbs-up-label">
                                                                {isLikedByViewer ? 'Liked' : 'Like'}
                                                            </span>
                                                        </button>
                                                    )}
                                                </span>
                                            </p>
                                            <p><strong>Date Added:</strong> {collectionItemData.dataAddedFormatted}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="vci-action-row">
                                    {canMessageOwner && (
                                        <button
                                            type="button"
                                            className="view-button vci-btn-primary"
                                            onClick={handleMessageOwner}
                                            disabled={messagingOwner}
                                        >
                                            {messagingOwner ? 'Opening…' : 'Message User'}
                                        </button>
                                    )}
                                    {user && isOwner && (
                                        <>
                                            <button
                                                onClick={handleEditClick}
                                                className="view-button">
                                                Edit
                                            </button>
                                            {canManageMarketplaceListing ? (
                                                <button
                                                    onClick={() =>
                                                        handleViewMarketplaceListing({
                                                            openEdit: isRejectedListing,
                                                        })
                                                    }
                                                    className="view-button vci-btn-primary">
                                                    {isRejectedListing
                                                        ? 'Edit listing'
                                                        : isRemovedListing || isExpiredListing || isUnderReviewListing
                                                            ? 'Manage listing'
                                                            : 'View Marketplace Listing'}
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={handleSellOnMarketplace}
                                                    className="view-button vci-btn-primary">
                                                    List for Sale
                                                </button>
                                            )}
                                        </>
                                    )}
                                    {!isOwner && isListedForSale && (
                                        <button
                                            type="button"
                                            onClick={() => handleViewMarketplaceListing()}
                                            className="view-button vci-btn-primary">
                                            View Marketplace Listing
                                        </button>
                                    )}
                                    {!isOwner && (
                                        <Link className="vci-owner-link" to={`/searchUsersCollection/${collectionItemData?.userId}`}>
                                            <button className="view-button">
                                                View {collectionItemData?.username || 'User'}'s Collection
                                            </button>
                                        </Link>
                                    )}
                                    {user && (
                                        <button
                                            onClick={handleDuplicateClick}
                                            className="view-button vci-btn-primary">
                                            Add Another Like This
                                        </button>
                                    )}
                                </div>
                                <div className="share-buttons">
                                    <button
                                        className="share-button"
                                        onClick={() => {
                                            const url = window.location.href;
                                            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
                                        }}
                                    >
                                        <i className="fab fa-facebook-f"></i>&nbsp; Facebook
                                    </button>
                                    <button
                                        className="share-button"
                                        onClick={() => {
                                            const url = window.location.href;
                                            const text = encodeURIComponent(`Check out this collectible! ${url}`);
                                            window.open(`https://twitter.com/intent/tweet?text=${text}`, '_blank');
                                        }}
                                    >
                                        <i className="fab fa-x-twitter"></i>&nbsp; X
                                    </button>
                                    <button
                                        className="share-button"
                                        onClick={() => {
                                            const url = window.location.href;
                                            const text = `Check out this collectible! ${url}`;
                                            window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`, '_blank');
                                        }}
                                    >
                                        <i className="fab fa-whatsapp"></i>&nbsp; WhatsApp
                                    </button>
                                    <button
                                        className="share-button"
                                        onClick={() => {
                                            const url = window.location.href;
                                            window.open(`https://www.facebook.com/dialog/send?link=${encodeURIComponent(url)}&app_id=YOUR_APP_ID&redirect_uri=${encodeURIComponent(url)}`, '_blank');
                                        }}
                                    >
                                        <i className="fab fa-facebook-messenger"></i>&nbsp; Messenger
                                    </button>
                                </div>

                                <div className="comments-section">
                                    <h3>Comments</h3>
                                    <div className="comments-scroll-box">
                                        {collectionItemData.comments && collectionItemData.comments.length > 0 ? (
                                            collectionItemData.comments.map((comment, index) => {
                                                const isOwnerComment =
                                                    comment.username &&
                                                    collectionItemData.username &&
                                                    comment.username.toLowerCase() === collectionItemData.username.toLowerCase();
                                                return (
                                                    <div
                                                        key={index}
                                                        className={`comment-bubble${isOwnerComment ? ' comment-bubble--owner' : ''}`}
                                                    >
                                                        <div className="comment-meta">
                                                            <strong>{comment.username}</strong>
                                                            {isOwnerComment && <span className="comment-owner-badge">Owner</span>}
                                                            <span className="comment-meta-sep">·</span>
                                                            {comment.dateTimePostedFormatted}
                                                        </div>
                                                        <div className="comment-text">{comment.comment}</div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="no-comments">Currently no Comments</div>
                                        )}
                                    </div>
                                    {user && (
                                        <div className="comment-input-section">
                                            <textarea
                                                className="comment-input"
                                                rows="2"
                                                placeholder="Leave a comment..."
                                                value={commentText}
                                                onChange={(e) => setCommentText(e.target.value)}
                                            />
                                            <button className="comment-submit" onClick={handlePostComment} disabled={!commentText.trim()} aria-label="Post comment">
                                                ➤
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="vci-bottom-bar">
                                    {user && user.userId === collectionItemData.userId && (
                                        <button
                                            type="button"
                                            onClick={handleDeleteClick}
                                            className="delete-button vci-delete-action">
                                            Delete
                                        </button>
                                    )}
                                </div>

                            </>
                        )}

                </div>
            </MsvDetailShell>
            <ConfirmDialog
                open={showDeleteConfirm}
                title="Confirm Deletion"
                message="Are you sure you want to delete this collectible? This action cannot be undone."
                confirmLabel="Yes, Delete"
                cancelLabel="Cancel"
                busy={deletingCollectible}
                onConfirm={confirmDeleteCollectible}
                onCancel={() => !deletingCollectible && setShowDeleteConfirm(false)}
            />
        </>
    );
};

export default ViewCollectionItem;